import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '../_utils/storage/storage.service';

@Injectable()
export class LangInterceptor implements HttpInterceptor {

  constructor(private storageService: StorageService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const lang = this.storageService.get('lang', false);
    if (!lang) {
      return next.handle(request);
    } else {
      const modifiedRequest = request.clone({
        setHeaders: {
          'X-Lang': lang
        }
      })
      return next.handle(modifiedRequest);
    }
  }
}